module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_25_30.f77b5628.png";